/* Maison Lumina - sélecteur « 1 / 2 » : la paire −10 % (lampes) ou −15 % sur la 2e (veilleuses) */
(function () {
  "use strict";
  var box = document.querySelector("[data-pair]");
  if (!box) return;
  var rate = Number(box.getAttribute("data-rate")) || 0.9;
  var mode = box.getAttribute("data-mode") || "both";
  var twoLabel = box.getAttribute("data-two-label") || "Ajouter la paire — ";
  var qty = document.getElementById("pairQty");
  var idIn = document.getElementById("variantId");
  var main = document.getElementById("mainPrice");
  var btn = document.getElementById("addCartBtn");
  var opts = Array.prototype.slice.call(box.querySelectorAll(".pair-opt"));
  var data = [];
  try { data = JSON.parse(document.getElementById("variantData").textContent); } catch (e) {}
  function money(c) { return (c / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €"; }
  function cur() {
    for (var i = 0; i < data.length; i++) if (idIn && String(data[i].id) === String(idIn.value)) return data[i];
    return data[0];
  }
  function label(text) {
    if (!btn || btn.disabled) return;
    var n = btn.firstChild;
    if (n && n.nodeType === 3) n.nodeValue = text;
  }
  function paint() {
    var v = cur(); if (!v) return;
    var q = Number(qty.value) === 2 ? 2 : 1;
    var unit = v.price;
    var pair = mode === "second" ? unit + Math.round(unit * rate) : Math.round(unit * 2 * rate);
    box.querySelector("[data-unit]").textContent = money(unit);
    box.querySelector("[data-pair-price]").textContent = money(pair);
    box.querySelector("[data-pair-was]").textContent = money(unit * 2);
    opts.forEach(function (o) {
      var on = o.getAttribute("data-q") === String(q);
      o.classList.toggle("is-on", on);
      o.setAttribute("aria-checked", on ? "true" : "false");
    });
    if (main) main.textContent = money(q === 2 ? pair : unit);
    label(q === 2 ? twoLabel : "Ajouter au panier — ");
  }
  opts.forEach(function (o) {
    o.addEventListener("click", function () { qty.value = o.getAttribute("data-q"); paint(); });
  });
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("[data-opt-group]")) setTimeout(paint, 0);
  });
  paint();
})();
